<script setup lang="ts">
import { CheckCircleIcon } from '@gohighlevel/ghl-icons/24/outline'
import { PaymentSuccessSVG } from '@gohighlevel/ghl-proposals-common'
import BaseDocument from './BaseDocument.vue'
import ViewerLayout from '@/components/layouts/ViewerLayout.vue'
import { UITextMdNormal } from '@gohighlevel/ghl-ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <BaseDocument
    :child-loading="false"
    :loaderText="t('documentViewer.verifying')"
    :skip-document-fetch="true"
  >
    <ViewerLayout>
      <div class="flex flex-col flex-1 justify-center">
        <PaymentSuccessSVG
          :alt="t('documentViewer.statusSuccessAlt')"
          :style="{ marginBottom: '4em' }"
          aria-hidden="true"
        />
        <div class="flex flex-col gap-4 items-center">
          <div class="flex items-center">
            <CheckCircleIcon class="h-5 w-5 text-green-500 mr-2" />
            <UITextMdNormal>{{ $t('documentViewer.allDone') }}</UITextMdNormal>
          </div>
          <div class="flex items-center">
            <UITextMdNormal>{{
              $t('documentViewer.declineSuccess')
            }}</UITextMdNormal>
          </div>
        </div>
      </div>
    </ViewerLayout>
  </BaseDocument>
</template>
